import * as React from 'react';

export default (props) => {
  let strokeColor;

  if (props.color) {
    strokeColor = props.color;
  } else {
    switch (props.state) {
      case 'hover':
        strokeColor = '#0A132B';
        break;
      case 'static':
        strokeColor = '#6C7280';
        break;
      case 'active':
        strokeColor = '#0067F4';
        break;
      default:
        strokeColor = '#B5BFD2';
    }
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 16v-1a9 9 0 1 1 18 0v1"
      />
      <path
        stroke={strokeColor}
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10.414 17.778a2 2 0 0 0 2.829 0l.25-.25c.303-.303.554-.652.746-1.033L17 11l-5.383 2.97a4 4 0 0 0-.896.673l-.307.307a2 2 0 0 0 0 2.828Z"
      />
    </svg>
  );
};
